import { FieldValues } from 'react-hook-form';

import { fdApi } from '../../../core/api';
import { Coordinates } from '../../../core/api/general/general.types';
import * as Api from '../../Api';
import { GoogleGeocodeResponse } from '../../component/CustomLocation';
import { Utilities } from '../../Utilities';

const createDeliveryLocation = async (requestParams: {
  countryCode: string;
  deviceId: string;
  fieldValues: FieldValues;
  locationGeo: Coordinates;
}): Promise<{
  DeliveryLocationId: number;
}> => {
  const { countryCode, deviceId, fieldValues, locationGeo } = requestParams;

  const addressFields = {
    ...fieldValues,
  };
  delete addressFields.instructions;

  const requestPayload = {
    addressFields,
    autoSelectThisLocation: false,
    coordinates: locationGeo,
    countryCode,
    deliveryInstructions: fieldValues.instructions,
    deviceId,
    isCustomAddress: true,
    isDisplayed: true,
  };

  const response = await fdApi
    .use(fdApi.user.location.postDeliveryLocationForm(requestPayload))
    .then((data: { DeliveryLocationId: number }) => data);

  return response;
};

const getAddressI18nFormScheme = (
  language: string,
  geocodeResponseResults: GoogleGeocodeResponse,
): Promise<Api.AddressI18nFormScheme> =>
  fdApi
    .use(
      fdApi.user.location.postFormatGoogleAddress(
        language,
        geocodeResponseResults,
      ),
    )
    .then((data: Api.AddressI18nFormScheme) => data);

const getDeliveryLocations = async (
  deviceId: string,
  language: string,
): Promise<Api.DeliveryLocation[]> => {
  const response = await fdApi
    .use(fdApi.user.location.getDeliveryLocationForms(deviceId, language))
    .then((data: Api.DeliveryLocationResponse) => data.DeliveryLocations);

  Utilities.setInLocalStorage('flipdish-delivery-locations', response);

  return response;
};

export {
  createDeliveryLocation,
  getAddressI18nFormScheme,
  getDeliveryLocations,
};
